module.exports = __webpack_public_path__ + "static/media/home.99ba5551.svg";